module.exports = __webpack_public_path__ + "img/rating-grn-_pMNyoy.svg";